import SelectInput from 'components/atoms/form/SelectInput/SelectInput'
import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import { Form, Formik } from 'formik'
import moment from 'moment'
import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import DayPicker, { DateUtils } from 'react-day-picker'
import 'react-day-picker/lib/style.css'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import RateplansService from 'services/RateplansService'
import {getCurrentDate, getDateStringFromDate, groupBy, isArrayNotEmpty, isCompletedHotelInfoHistory, isReadOnly} from 'utilities/JSUtil'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import Button from '../../../atoms/Button/Button'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './RateplanBlackouts.scss'

/**
 * Rateplan Blackouts
 */
class RateplanBlackouts extends Component {

    currentYear = getCurrentDate().getFullYear()
    nextYear = this.currentYear + 1

    constructor(props) {
        super(props)
        let hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        let hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
        const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY)
        let onboardingStatus = getSessionItem(SessionConst.ONBOARDING_STATUS)

        if (!hotelCode || !hotelInfo) {
            // Go home
            this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
        }

        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            initialValues: {},
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            showResetModal: false,
            showErrorModal: false,
            isEdit: false,
            editYear: undefined,
            editRatePlan: undefined,
            editIndex: -1,
            blackouts: [],
            hotelInfoCompletedHistory: hotelInfoCompletedHistory,
            showDayPicker: false,
            ratePlanCodeSelected: false,
            onboardingStatus: onboardingStatus.status ? onboardingStatus.status : ''
        }
    }

    /**
     * Adds or deletes a particular day from blackouts
     * @param {string} day the selected day
     * @param {object} param1 contains the boolean value selected which indicates if the date is selected or deselected
     * @param {Array} blackoutDays the blackout days list from the form values object
     * @param {Number} editIndex the index for blackoutDays list which needs to be updated
     * @param {Number} selectedYear the year within the select blackoutDays object which needs to be updated
     */
    handleDayClick = (day, { selected }, blackoutDays, editIndex, selectedYear) => {
        // Retrieve the blackout which is being edited
        let blackoutDaysForSelectedYear = blackoutDays[editIndex][selectedYear]

        // If already selected, then remove the day from blackouts
        // Otherwise, add it to the blackouts
        if (selected) {
            const selectedIndex = blackoutDaysForSelectedYear.findIndex(selectedDay =>
                DateUtils.isSameDay(selectedDay, day)
            )
            blackoutDaysForSelectedYear.splice(selectedIndex, 1)
        } else {
            blackoutDaysForSelectedYear.push(day)
        }

        // Update the blackouts array with the updated object
        blackoutDays.splice(editIndex, 1, {
            ...blackoutDays[editIndex],
            [selectedYear]: [...blackoutDaysForSelectedYear]
        })

        // Set the new values in the state
        this.setState({
            consolidatedBlackouts: blackoutDays
        })
    }

    // No validation
    validationSchema = Yup.object().shape({
    })

    // Initial values for form
    initialValues = {
        consolidatedBlackouts: [],
        isSTATE: false,
        isSGM: false,
        isSED: false,
        isSFF: false,
        selectedYear: this.currentYear
    }

    async componentDidMount() {
        if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory)) {
            let blackouts = this.state.hotelInfoCompletedHistory.newEntity?.blackouts;

            if (blackouts && blackouts.blackouts) {
                await this.buildFormValues(blackouts.blackouts);
            } else {
                this.setState({error: 'Could not retrieve details', isLoading: false})
            }
        } else {
            await RateplansService.getBlackouts({ hotelCode: this.state.hotelCode })
                .then(async response => {
                    let blackouts = response?.blackouts;
                    if (blackouts) {
                        await this.buildFormValues(blackouts);
                    }
                }).catch(error => {
                    this.setState({
                        isLoading: false,
                        showErrorModal: true,
                        errorMessage: 'There was an error while reading blackouts data'
                    })
                })
        }
    }

    async buildFormValues(blackoutsSessionObject) {
        let blackouts = []
        let isSGM = false
        let isSTATE = false
        let isSED = false
        let isSFF = false
        if (isArrayNotEmpty(blackoutsSessionObject)) {
            // Group the blackouts by rateplan
            const blackoutsByRateplan = groupBy(blackoutsSessionObject, FormConst.FIELD_RATEPLAN_CODE)

            // Set the flags for STATE, SGM, SED and SFF to determine if they are present in the blackouts response
            // This will later be used to combine dates for these rateplans
            // Right now, STATE and SGM will have same set of blackout dates
            Object.keys(blackoutsByRateplan).forEach(ratePlanCode => {
                switch (ratePlanCode) {
                    case FormConst.RATEPLAN_CODE_STATE:
                        isSTATE = true
                        break
                    case FormConst.RATEPLAN_CODE_SGM:
                        isSGM = true
                        break
                    case FormConst.RATEPLAN_CODE_SED:
                        isSED = true
                        break
                    case FormConst.RATEPLAN_CODE_SFF:
                        isSFF = true
                        break
                }
            })

            // For each rateplan code, capture blackout dates and set initial values
            for (const rateplanCode in blackoutsByRateplan) {
                if (Object.hasOwnProperty.call(blackoutsByRateplan, rateplanCode)) {
                    const blackoutsForRateplan = blackoutsByRateplan[rateplanCode]
                    const ratePlanName = blackoutsForRateplan[0].ratePlanName
                    // Set the blackout for the rate plan with max days and entries for current and next year
                    // The UI only allows blackouts for 2 years
                    let blackout = {
                        maxBlackoutDays: blackoutsForRateplan[0].maxBlackoutDays,
                        [this.currentYear]: [],
                        [this.nextYear]: []
                    }

                    // Iterate through all the blackout days ranges for the rate plan
                    // and enumerate to days.
                    // The UI uses a calendar view where each date can be selected
                    let individualBlackoutDaysInResponse = []
                    blackoutsForRateplan.forEach(blackout => {
                        individualBlackoutDaysInResponse.push(...this.enumerateDaysBetweenDates(blackout.startDate, blackout.endDate))
                    })
                    // Sort the days and push them into the corresponding year field within blackouts object
                    individualBlackoutDaysInResponse.sort()
                    individualBlackoutDaysInResponse.forEach(date => {
                        const year = moment(date).year()
                        if (blackout[year]) {
                            blackout[year].push(date)
                        } else {
                            blackout[year] = []
                            blackout[year].push(date)
                        }
                    })

                    // Combine STATE and SGM based on their presence in the blackouts response
                    // If both are present then show a single entry with both rate plan codes
                    // Display the other rate plans separately
                    // Push the entries to blackouts array
                    if (
                        (rateplanCode === FormConst.RATEPLAN_CODE_STATE && isSTATE)
                        || (rateplanCode === FormConst.RATEPLAN_CODE_SGM && !isSTATE)
                    ) {
                        blackout = {
                            ...blackout,
                            [FormConst.FIELD_RATEPLAN_CODE]: isSTATE && isSGM
                                ? FormConst.RATEPLAN_CODE_STATE_SGM
                                : isSTATE ? FormConst.RATEPLAN_CODE_STATE : FormConst.RATEPLAN_CODE_SGM,
                            [FormConst.FIELD_RATEPLAN_NAME]: FormConst.RATEPLAN_NAME_STATE_SGM
                        }
                        blackouts.push(blackout)
                    } else if (rateplanCode !== FormConst.RATEPLAN_CODE_STATE
                        && rateplanCode !== FormConst.RATEPLAN_CODE_SGM) {
                        blackout = {
                            ...blackout,
                            [FormConst.FIELD_RATEPLAN_CODE]: rateplanCode,
                            [FormConst.FIELD_RATEPLAN_NAME]: ratePlanName,
                        }
                        blackouts.push(blackout)
                    }
                }
            }
        }

        // Set the state
        this.setState({
            initialValues: {
                ...this.state.initialValues,
                consolidatedBlackouts: blackouts,
                selectedYear: this.currentYear
            },
            isLoading: false
        })
    }

    /**
     * Builds a payload for PUT blackout for the given date range
     * @param {string} rateplanCode rateplan code
     * @param {string} startDate start date for blackout
     * @param {string} endDate end date for black out
     * @returns the blackout object for given date range
     */
    buildPutObjectForRateplanBlackouts = (rateplanCode, startDate, endDate) => {
        return {
            ratePlanCode: rateplanCode,
            startDate: startDate,
            endDate: endDate,
        }
    }

    /**
     * Converts the form data into the required payload and submits a PUT request
     * @param {object} data formData with blackouts info
     */
    handleSubmit = (data) => {
        // Get the blackouts
        let blackouts = data.consolidatedBlackouts

        // Build basic put data
        let putData = {
            hotelCode: this.state.hotelCode,
            blackouts: []
        }

        // For each blackout from form data, convert the data in required format for sending a PUT request
        blackouts.forEach(blackout => {
            let putBlackouts = []
            // For both year, current and next, look at all individual blackout days and combine them into date ranges
            for (const year in blackout) {
                if (Object.hasOwnProperty.call(blackout, year) && (year === this.currentYear.toString() || year === this.nextYear.toString())) {
                    const blackoutsForYear = blackout[year]
                    blackoutsForYear.forEach(date => putBlackouts.push(date))
                }
            }
            putBlackouts.sort()
            const contiguousDates = this.getRelativeDates(putBlackouts)
            contiguousDates.forEach(contiguousDatesEntry => {
                const startDate = contiguousDatesEntry[0]
                const endDate = contiguousDatesEntry[contiguousDatesEntry.length - 1]

                if (endDate > getCurrentDate()) {
                    if (startDate < getCurrentDate()) {
                        startDate = getCurrentDate();
                    }
                    
                    // If STATE and SGM are both present, then add blackouts for each rate plan separately
                    if (blackout.ratePlanCode === FormConst.RATEPLAN_CODE_STATE_SGM) {
                        putData.blackouts.push(this.buildPutObjectForRateplanBlackouts(FormConst.RATEPLAN_CODE_STATE, getDateStringFromDate(startDate), getDateStringFromDate(endDate)))
                        putData.blackouts.push(this.buildPutObjectForRateplanBlackouts(FormConst.RATEPLAN_CODE_SGM, getDateStringFromDate(startDate), getDateStringFromDate(endDate)))
                    } else {
                        putData.blackouts.push(this.buildPutObjectForRateplanBlackouts(blackout.ratePlanCode, getDateStringFromDate(startDate), getDateStringFromDate(endDate)))
                    }
                }
            })
        })
        // Send PUT request
        this.props.onPut(putData)
        // Update state to show loading modal
        this.setState({ isLoading: true, loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT })
    }

    /**
     * Converts a list of individual dates to date ranges
     * @param {Array} dates list of dates to be converted to date ranges
     * @returns list of date ranges with startDate and endDate
     */
    getRelativeDates = (dates) => {
        let format = 'YYYY-MM-DD'
        let newDate = []
        dates.forEach(function (date) {
            let lastArr
            if (newDate.length) {
                lastArr = newDate[newDate.length - 1]
                if (!lastArr.length)
                    lastArr.push(date)
                else {
                    let lastDate = lastArr[lastArr.length - 1]
                    if (moment(lastDate, format).add(1, 'd').format(format) == date)
                        lastArr.push(date)
                    else
                        newDate.push([date])
                }
            }
            else
                newDate.push([date])
        })
        return newDate
    }

    /**
     * Converts date range to list of individual dates
     * @param {string} startDate start date
     * @param {string} endDate end date
     * @returns List of dates
     */
    enumerateDaysBetweenDates = (startDate, endDate) => {
        var dates = []

        if (!!startDate && !!endDate) {
            var currDate = moment(startDate).startOf('day')
            var lastDate = moment(endDate).startOf('day')
            while (currDate.diff(lastDate) <= 0) {
                dates.push(currDate.clone().toDate())
                currDate.add(1, 'days')
            }
        }
        return dates
    }

    /**
     * Checks if the number of selected dates for a particular rate plan 
     * has exceeded the max blackout days count for that rate plan
     * @param {string} blackoutsPerRateplan the list of selected blackout dates for a rate plan
     * @returns if the blackout limit has been exceeded
     */
    isBlackoutsLimitExceeded = (blackoutsPerRateplan) => {
        return blackoutsPerRateplan[this.currentYear].length > blackoutsPerRateplan.maxBlackoutDays
            || blackoutsPerRateplan[this.nextYear].length > blackoutsPerRateplan.maxBlackoutDays
    }

    /**
     * Lifecycle method to handle this component's update. Only handles updates which are a result of HTTP async actions.
     * 
     * @param {Object} prevProps properties before the current update
     */
    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            // If the request failed, update the state to show error modal
            if (this.props.errorMessage) {
                this.setState({
                    isLoading: false,
                    errorMessage: this.props.errorDescription,
                    showErrorModal: true
                })
            } else {
                // If the request is successful, redirect to the rate plans home page
                this.props.history.push(RouteConst.ROUTE_RATEPLANS_PAGE)
            }
        }
    }

    render() {
        return (
            <Formik
                initialValues={this.state.initialValues}
                validationSchema={this.validationSchema}
                enableReinitialize={true}
                onSubmit={(data, { setSubmitting, resetForm }) => {
                    setSubmitting(true)
                    this.handleSubmit(data)
                    setSubmitting(false)
                }}>
                {
                    ({ values, errors, touched, dirty, isSubmitting, isValid, resetForm, handleChange, setFieldValue }) => (
                        <Form>
                            <div className='rateplan-blackouts-form'>
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_HOME_PAGE}>Home</NavLink></li>
                                        <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_RATEPLANS_PAGE}>Rateplans</NavLink></li>
                                        <li className="breadcrumb-item active" aria-current="page">Rateplan Blackouts</li>
                                    </ol>
                                </nav>
                                <p className='helper-text'>{FormConst.RATEPLAN_BLACKOUTS_HELPER_TEXT}</p>
                                <div id='rateplan-blackouts-form-fields' className='rateplan-blackouts-form-fields'>
                                    {
                                        values.consolidatedBlackouts &&
                                        (
                                            <>
                                                {/* Blackouts table with list of available rate plans */}
                                                <table className='table table-striped'>
                                                    <thead>
                                                        <tr>
                                                            <th>Rate Plan code</th>
                                                            <th>Rate Plan name</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            isArrayNotEmpty(values.consolidatedBlackouts)
                                                                ? values.consolidatedBlackouts.map((blackout, index) => {
                                                                    return <tr key={index}>
                                                                        <td>{blackout.ratePlanCode}</td>
                                                                        <td>{blackout.ratePlanName}</td>
                                                                        <td>
                                                                            {(this.state.onboardingStatus === FormConst.STATUS_COMPLETED || this.state.onboardingStatus === FormConst.STATUS_READY_FOR_REVIEW) ?
                                                                                (this.state.ratePlanCodeSelected && this.state.editIndex === index) ?
                                                                                    <Button name='Selected Rate Plan' role='link' onClick={() => {
                                                                                        this.setState({
                                                                                            editIndex: index,
                                                                                            showDayPicker: true,
                                                                                            ratePlanCodeSelected: true
                                                                                        })
                                                                                    }} className='icon-link dark-color' overridedisabledflag='true' />
                                                                                    : <Button name='View Blackout Dates' role='link' onClick={() => {
                                                                                        this.setState({
                                                                                            editIndex: index,
                                                                                            showDayPicker: true,
                                                                                            ratePlanCodeSelected: true
                                                                                        })
                                                                                    }} className='icon-link dark-color' overridedisabledflag='true' />
                                                                                : this.state.isEdit && this.state.editIndex === index ?
                                                                                      <Button role='link' id={`edit-${index}`}
                                                                                        name='Save Blackout Dates'
                                                                                        onClick={() => {
                                                                                            this.setState({
                                                                                                isEdit: false,
                                                                                                editIndex: -1
                                                                                            })
                                                                                        }}
                                                                                        disabled={this.isBlackoutsLimitExceeded(blackout)} />
                                                                                    : <Button role='link' id={`edit-${index}`}
                                                                                        name={blackout[this.currentYear].length > 0 || blackout[this.nextYear].length > 0
                                                                                            ? 'Adjust Blackout Dates'
                                                                                            : 'Set Blackout Dates'} onClick={() => {
                                                                                                this.setState({
                                                                                                    isEdit: true,
                                                                                                    editIndex: index
                                                                                                })
                                                                                            }}
                                                                                        disabled={this.state.isEdit && this.state.editIndex !== index} />
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                })
                                                                : <tr>
                                                                    <td colSpan={3}>
                                                                        No applicable rate plans opted in to select blackout dates.
                                                                            </td>
                                                                </tr>
                                                        }
                                                    </tbody>
                                                </table>

                                                {/* Edit view with selected year and calendar */}
                                                {
                                                    (this.state.isEdit || this.state.showDayPicker) &&
                                                    (
                                                        <div className='select-dates-view'>
                                                            <p className='select-dates-view-title'>Select Blackout dates</p>
                                                            <SelectInput
                                                                id='select-year'
                                                                label='Year: '
                                                                name='selectedYear'
                                                                options={[{ label: this.currentYear.toString(), value: this.currentYear.toString() }, { label: this.nextYear.toString(), value: this.nextYear.toString() }]}
                                                                overridedisabledflag='true'
                                                                title='Year' />

                                                            {/* Helper info with counts and error messages */}
                                                            <Row>
                                                                <Col xs={12} xl={4} className='error text-xs-center text-xl-left'><p>Total remaining: <span className='text-bold large-font'>{!(this.state.onboardingStatus === FormConst.STATUS_COMPLETED) ? values.consolidatedBlackouts[this.state.editIndex].maxBlackoutDays - values.consolidatedBlackouts[this.state.editIndex][values.selectedYear].length : ''}</span></p></Col>
                                                                <Col xs={12} xl={4} className='error text-center'>
                                                                    {
                                                                        this.isBlackoutsLimitExceeded(values.consolidatedBlackouts[this.state.editIndex])
                                                                        && <p>You cannot select more than <span className='text-bold'>{values.consolidatedBlackouts[this.state.editIndex].maxBlackoutDays}</span> days per year.</p>
                                                                    }
                                                                </Col>
                                                                <Col xs={12} xl={4} className='error text-xs-center text-xl-right'><p>Total selected: <span className='text-bold large-font'>{values.consolidatedBlackouts[this.state.editIndex][values.selectedYear].length}</span></p></Col>
                                                            </Row>

                                                            {/* Legend */}
                                                            <div>
                                                                <ul className="legend">
                                                                    <li><span className="legend-blue"></span> Selected</li>
                                                                    <li><span className="legend-red"></span> Current Date</li>
                                                                </ul>
                                                            </div>
                                                            {/* Day picker */}
                                                            <DayPicker
                                                                numberOfMonths={12}
                                                                month={new Date(values.selectedYear, 0)}
                                                                canChangeMonth={false}
                                                                disabledDays={{ before: new Date() }}
                                                                selectedDays={values.consolidatedBlackouts[this.state.editIndex][values.selectedYear]}
                                                                onDayClick={(day, { selected }) => this.handleDayClick(day, { selected }, values.consolidatedBlackouts, this.state.editIndex, values.selectedYear)}
                                                                className={isReadOnly() ? 'disable' : ''} />
                                                            {/* Show error when blackout limit is exceeded */}
                                                            {
                                                                this.isBlackoutsLimitExceeded(values.consolidatedBlackouts[this.state.editIndex])
                                                                && <p className='error text-center'>You cannot select more than <span className='text-bold'>{values.consolidatedBlackouts[this.state.editIndex].maxBlackoutDays}</span> days per year.</p>
                                                            }
                                                            {/* Save button - Will not send a service request */}
                                                            <Button id={`save-button`}
                                                                className='save-dates-button'
                                                                name='Save Dates' onClick={() => {
                                                                    this.setState({
                                                                        isEdit: false,
                                                                        editIndex: -1
                                                                    })
                                                                }}
                                                                disabled={this.isBlackoutsLimitExceeded(values.consolidatedBlackouts[this.state.editIndex])} />
                                                        </div>
                                                    )
                                                }
                                            </>
                                        )
                                    }
                                </div>

                                <FormFooter
                                    form={{
                                        previous: { title: 'Other Rate Plans', route: RouteConst.ROUTE_OTHER_RATEPLANS_PAGE },
                                        next: { title: 'Rate Plans', route: RouteConst.ROUTE_RATEPLANS_PAGE }
                                    }}
                                    isSubmit
                                    submitName={FormConst.SAVE_BUTTON_TEXT}
                                    noReset
                                    submitDisabled={isSubmitting} />
                                <FormModal
                                    id='rateplan-blackouts-page-save-modal'
                                    title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                    hotelInfo={this.state.hotelInfo}
                                    body={<h6>{this.state.loadingMessage}</h6>}
                                    show={this.state.isLoading}
                                    isLoadingIndicator />
                                <FormModal
                                    id='rateplan-blackouts-page-reset-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title={FormConst.MODAL_RESET_ACTION_TITLE}
                                    body={<h5>{FormConst.MODAL_RESET_ACTION_TEXT}</h5>}
                                    proceed={() => {
                                        this.resetFormData(resetForm)
                                    }}
                                    cancel={() => { this.setState({ showResetModal: false }) }}
                                    show={this.state.showResetModal} />
                                <FormModal
                                    id='rateplan-blackouts-page-error-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                    body={<h5>{this.state.errorMessage}</h5>}
                                    isError
                                    cancel={() => { this.setState({ showErrorModal: false }) }}
                                    show={this.state.showErrorModal} />
                            </div>
                        </Form>
                    )
                }
            </Formik>
        )
    }
}

// Updates the component properties based on redux state
const mapStateToProps = state => {
    return {
        blackoutsResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count
    }
}

// Maps the redux dispatch methods to the component's properties
const mapDispatchToProps = dispatch => {
    return {
        onPut: (data) => dispatch(asyncMethod(FormConst.FORM_RATEPLAN_BLACKOUTS_NAME, actionTypes.ASYNC_ACTIONS.PUT, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(RateplanBlackouts, SideNavEntryMapping.RATE_PLANS))